//@ts-nocheck

import styled, { css } from 'styled-components'
import { StyledButton } from '../../atoms/Button/Button.styles'
import { ColorSchemeTypes } from '../../../types/ColorScheme'
import { Heading, Paragraph } from '../../atoms/Typography/Typography.styles'

interface FaqProps {
  theme: any
  colorScheme?: ColorSchemeTypes
}

interface FaqSimpleHeaderProps {
  theme: any
}

interface FaqSpecifiedWrapperProps {
  theme: any
}

export const Faq = styled.div<FaqProps>`
  border-radius: ${({ theme }) => theme.rem(24)};
  padding-top: ${({ theme }) => theme.rem(24)};
  padding-bottom: ${({ theme }) => theme.rem(24)};

  ${({ theme }) => theme.mediaQuery.lg(`
    padding-top: ${theme.rem(60)};
    padding-bottom: ${theme.rem(60)};
  `)}
  
  ${({ theme }) => theme.mediaQuery.xl(`
    padding-top: ${theme.rem(60)};
    padding-bottom: ${theme.rem(60)};
    padding-left: ${theme.rem(36)};
    padding-right: ${theme.rem(36)};
  `)}

  ${({ theme, colorScheme }) => css`
    background-color: ${theme.colorScheme[`${colorScheme}`].surface.inside};
    color: ${theme.colorScheme[`${colorScheme}`].surface.text.base.primary};
  `}

  ${Paragraph},
  ${Heading} {
    color: ${({ theme, colorScheme }) => theme.colorScheme[colorScheme].surface.text.base.primary};
  }
`

export const FaqSimpleHeader = styled.div<FaqSimpleHeaderProps>`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: ${({ theme }) => theme.rem(40)};

  ${({ theme }) => theme.mediaQuery.lg(`
    flex-direction: column;
    margin-bottom: ${theme.rem(16)};

    ${StyledButton} {
      margin-top: ${theme.rem(16)};
    }
  `, true)}
`

export const FaqSpecifiedWrapper = styled.div<FaqSpecifiedWrapperProps>`
  &:not(:first-child) {
    margin-top: ${({ theme }) => theme.rem(40)};

    ${({ theme }) => theme.mediaQuery.lg(`
      margin-top: ${theme.rem(60)};
    `)}
  }
`
